<div class="container">
    <div class="row no-gutters">
        <h1 class="col-xs-12">Let's Plant Some Roots</h1>
        <div> </div>

        <form #form="ngForm" autocomplete="off" (submit)="onSubmit(form)">
            <input type="hidden" name="id" #id="ngModel" [(ngModel)]="plservice.formData.id">

            <!-- name -->
            <div class="form-group col-md-6 ">
                <input name="commonName" #commonName="ngModel" [(ngModel)]="plservice.formData.commonName"
                    class="form-control" placeholder="COMMON NAME" required>
                <!-- <div *ngIf="commonName.invalid && commonName.touched" class="validation-error">Plant name is required.</div> -->
            </div>

            <!-- scientific name -->
            <div class="form-group col-md-6">
                <input name="scientificName" #scientificName="ngModel" [(ngModel)]="plservice.formData.scientificName"
                    class="form-control" placeholder="SCIENTIFIC NAME">
            </div>

            <!-- light -->

            <div class="form-group col-md-6" required>
                <select name="light" #light="ngModel" [(ngModel)]="plservice.formData.light" class="form-control">
                    <option value="" disabled selected>LIGHT LEVEL</option>
                    <option value="DIRECT">DIRECT</option>
                    <option value="BRIGHT INDIRECT">BRIGHT INDIRECT</option>
                    <option value="MEDIUM LIGHT">MEDIUM LIGHT</option>
                    <option value="LOW LIGHT">LOWLIGHT</option>
                </select>
                <!-- <div *ngIf="light.invalid && light.touched" class="validation-error">Light level is required.</div> -->
            </div>

            <!-- water -->

            <div class="form-group col-md-6" required>
                <select name="water" #water="ngModel" [(ngModel)]="plservice.formData.water" class="form-control">
                    <option value="" disabled selected>WATER LEVEL</option>
                    <option value="DRY">DRY</option>
                    <option value="DRY BETWEEN WATERINGS">DRY BETWEEN WATERINGS</option>
                    <option value="MOIST">KEEP MOIST</option>
                    <option value="WET">WET</option>
                </select>
            </div>

            <!-- temp -->

            <div class="form-group col-md-6" required>
                <select name="temp" #temp="ngModel" [(ngModel)]="plservice.formData.temp" class="form-control">
                    <option value="" disabled selected>LOWEST TEMP</option>
                    <option value="40">40<span>&#176;</span>F</option>
                    <option value="50">50<span>&#176;</span>F</option>
                    <option value="60">60<span>&#176;</span>F</option>
                    <option value="70">70<span>&#176;</span>F</option>
                </select>
            </div>

            <!-- humidity -->

            <div class="form-group col-md-6" required>
                <select name="humidity" #humidity="ngModel" [(ngModel)]="plservice.formData.humidity"
                    class="form-control">
                    <option value="" disabled selected>HUMIDITY</option>
                    <option value="LESS THAN 50%">LESS THAN 50%</option>
                    <option value="50%-60%">50%-60%</option>
                    <option value="60%-70%">60%-70%</option>
                    <option value="70%-80%">70%-80%</option>
                    <option value="80%+">80%+</option>
                </select>
            </div>

            <!-- date -->
            <!-- <div class="form-group">
            <label for="start">Last Watered:</label><br>

            <input type="date" id="start" name="waterDate" value="YYY-MM-DD" min="2021-01-01" max=""
                #waterDate="ngModel" [(ngModel)]="plservice.formData.waterDate" class="form-control" required>
             <div *ngIf="waterDate.invalid && waterDate.touched" class="validation-error">Last water date is required.</div> -->
            <!-- </div> -->

            <!-- notes -->
            <!-- <div class="form-group">
            <input commonName="notes" #notes="ngModel" [(ngModel)]="plservice.formData.notes" class="form-control"
                placeholder="NOTES">
        </div> -->

            <!-- submit -->

            <div class="submit form-group col-md-12">
                <button type="submit" [disabled]="form.invalid"
                    class="btn">Submit</button>
            </div>
        </form>

        <!-- error message -->
        <div class="error" *ngIf="message">
            <h5 class="text-success">{{ message }}</h5>
        </div>
    </div>
</div>